import { render, staticRenderFns } from "./PFormInputPredictiveSearch.vue?vue&type=template&id=12dbd222&scoped=true&"
import script from "./PFormInputPredictiveSearch.vue?vue&type=script&lang=ts&"
export * from "./PFormInputPredictiveSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PFormInputPredictiveSearch.vue?vue&type=style&index=0&id=12dbd222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbd222",
  null
  
)

export default component.exports